<template>
    <div class="vip-index-task">
        <!-- 会员日任务入口start -->
        <div class="vip-task-enter analysis"  @click.stop="VipTaskInfoShow" data-analysis="首页_会员任务_浮窗">
            <img src="../images/vip-task-enter.png">
        </div>
        <div class="vip-task-box" @click.stop="closeBox" v-show="VipTaskBoxShow">
            <div class="vip-task-wrap">
                <a :href="vipTask.TASK_DIRECT_URL">
                    <img :src="vipTask.TASK_IMG_URL">
                </a>
                <i class="vip-icon-close" @click.stop="closeBox">✕</i>
            </div>
        </div>
        <!-- 会员日任务入口end -->
    </div>
</template>

<script>

    export default{
        data(){
            return {
                vipTaskListImg:'',
                vipTaskListUrl:'',
                VipTaskBoxShow:false

            }
        },
        props:['vipTask'],
        mounted(){

        },
        methods:{
            VipTaskInfoShow() {
                this.VipTaskBoxShow = true;
            },
            closeBox(){
                this.VipTaskBoxShow = false;
            }
        }

    }
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "../../../resource/css/color";
    /*.vip-index-task {*/

        .vip-task-enter {
            position: fixed;
            left: 0;
            bottom: 1.1rem;
            z-index: 1;
        }

        .vip-task-enter img {
            width: 1.1rem;
            height: auto;
            display: block;
        }

        .vip-task-box {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 99999;
            background: rgba(0, 0, 0, .7);
        }

        .vip-task-wrap {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 5.8rem;
            -webkit-transform: translate(-50%, -50%);
        }

        .vip-task-wrap img, .vip-task-wrap a {
            width: 100%;
            height: auto;
            display: block;
        }

        .vip-icon-close {
            width: .9rem;
            height: .9rem;
            display: block;
            margin: 1rem auto 0;
            background: #ffffff;
            border-radius: .45rem;
            font-size: .4rem;
            line-height: .9rem;
            text-align: center;
            font-style: normal;
        }
    /*}*/

</style>


// WEBPACK FOOTER //
// src/pages/index/component/vip_task.vue